import {
  normalizePostalCode,
  normalizeZip,
} from '../lib/forms/normalizations';

export default {
  us: normalizeZip,
  ca: normalizePostalCode,
};
